import { API } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import {
  getInvoiceTrashMetaSafe,
  getInvoiceTrashVersionProbe,
} from "../graphqlCustom/queries";
import { finiteInvoiceMutationVersion } from "./invoiceMutationVersion";

type InvoiceMutationAuthMode =
  (typeof GRAPHQL_AUTH_MODE)[keyof typeof GRAPHQL_AUTH_MODE];

type TrashMetaOk = {
  id: string;
  deleted?: string | null;
  mutationVersion?: number;
};

/** AppSync rejects reading `_version` when Dynamo has null — schema declares Int!. */
export async function fetchInvoiceTrashMetaForMutation(
  id: string,
  authMode: InvoiceMutationAuthMode
): Promise<TrashMetaOk | null> {
  const safe = (await API.graphql({
    query: getInvoiceTrashMetaSafe,
    variables: { id },
    authMode,
  })) as {
    data?: { getInvoice?: { id?: string; deleted?: string | null } | null };
  };

  const row = safe?.data?.getInvoice;
  if (!row?.id) return null;

  let mutationVersion: number | undefined;
  try {
    const probe = (await API.graphql({
      query: getInvoiceTrashVersionProbe,
      variables: { id },
      authMode,
    })) as {
      data?: {
        getInvoice?: { id?: string; _version?: number | null } | null;
      };
      errors?: Array<{ message?: string; path?: (string | number)[] }>;
    };

    const probeRow = probe?.data?.getInvoice;
    const hasProbeErrors =
      Array.isArray(probe.errors) && probe.errors.length > 0;

    if (!hasProbeErrors && probeRow?.id) {
      mutationVersion = finiteInvoiceMutationVersion(probeRow._version);
    }
  } catch {
    mutationVersion = undefined;
  }

  return { id: row.id, deleted: row.deleted, mutationVersion };
}
